import styled from "styled-components";
import {
  TypoLabelStyles,
  TypoMenuStyles,
  TypoBodyStyles,
  TypoCaption2,
  TypoCaptionStyles,
} from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";

export const GridBsCardsWrapper = styled.div`
  display: grid;
  gap: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.formGap.xs,
      maxSize: theme.spacing.formGap.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
  padding-bottom: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-template-columns: 1fr;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 1fr;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: [outer-start] 1fr [center-start] 6fr [center-end] 1fr [outer-end];
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-rows: auto;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: ${({ theme }) => `
      0
      ${fluid({
        minSize: theme.spacing.formGap.xs,
        maxSize: theme.spacing.formGap.xl,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
  }
`;

export const GridItemBsCard = styled.div`
  padding-bottom: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-column: center-start / center-end;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    padding-bottom: 0;
  }
`;

export const GridBsCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.formGap.xs,
      maxSize: theme.spacing.formGap.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
`;

export const GridItemBsCardWrapper = styled.div`
  &:nth-of-type(2) {
    align-self: center;
    width: 90%;
  }
`;

export const BsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%; // Essential: the wrapper must fill the card's height
  text-align: center;
  // doubles the specificity.
  && {
    padding: 0;
  }
  p {
    margin: 0;
  }
  hr {
    text-align: center;
    width: 100px;
    height: 1px;
    border: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
    /* margin: 0 auto; */
    margin: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.card.xs,
        maxSize: theme.spacing.card.xl,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
      auto
    `};
  }
  ${TypoBodyStyles};
  h4 {
    ${TypoLabelStyles};
    font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
    padding: ${({ theme }) => theme.spacing.card.xs}rem 0 0;
  }
  h5 {
    ${TypoBodyStyles};
    span {
      color: ${({ theme }) => theme.colors.imperialRed};
      padding-bottom: 0;
      font-size: ${({ theme }) =>
        fluid({
          minSize: theme.fontScale.majorSecond.size, // 1.33333333
          maxSize: theme.fontScale.augmentedFourth.size, // 1.44444444
          minVW: theme.breakpointValues.xs, // 900
          maxVW: theme.breakpointValues.xl, // 1200 or 1800?
          baseFontMin: theme.baseFont.xs,
          baseFontMax: theme.baseFont.xl,
        })};
    }
  }
  ul {
    list-style: none;
    padding: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.card.xs,
        maxSize: theme.spacing.card.xl,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
      0
    `};
  }
  span {
    ${TypoCaptionStyles};
    display: inline-block;
    padding-bottom: ${({ theme }) =>
      fluid({
        minSize: theme.spacing.element.xs,
        maxSize: theme.spacing.element.xl,
        minVW: theme.breakpointValues.xs, // 900
        maxVW: theme.breakpointValues.xl, // 1200 or 1800?
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })};
  }
  a,
  button {
    margin-top: auto; /* Pushes the button to the bottom */
  }
`;

export const BsDescription = styled(TypoCaption2)`
  text-align: center;
`;
